import { useEffect, useState } from "react";
import { Container, Tab, Nav, Button } from "react-bootstrap";
import { MainTabSection } from "./myAccountStyle";
import PersonalFundraisers from "../../components/common/myPersonalFundraisersTab";
import MyReviewsTab from "../../components/common/myReviewsTab";
import FavoriteNonprofits from "../../components/common/favoriteNonprofitsTab";
import CausePreferences from "../../components/common/causePreferences";
import MyDonationsTab from "../../components/common/myDonationsTab";
import ManageAccountTab from "../../components/common/manageAccountTab";
import { MESSAGE } from "../../utils/message";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import MetaComponent from "../../components/common/metaComponent";

const MyAccountTab = () => {
  const user_id = typeof localStorage !== "undefined" && localStorage.getItem("userId");
  const [key, setKey] = useState<string>("account");
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const tabsList = [
    {
      title: MESSAGE.myPersonalFundraisers,
      key: "fundraisers",
      path: `profile/${user_id}/fundraisers/list`,
    },
    {
      title: MESSAGE.myReviews,
      key: "reviews",
      path: `profile/${user_id}`,
    },
    {
      title: MESSAGE.myFavoriteNonprofits,
      key: "favorites",
      path: `profile/${user_id}/favorites`,
    },
    {
      title: MESSAGE.myCausePreferences,
      key: "preferences",
      path: `preferences/${user_id}`,
    },
    {
      title: MESSAGE.myDonations,
      key: "donations",
      path: `donations/${user_id}`,
    },
    {
      title: MESSAGE.manageAccount,
      key: "account",
      path: "/users/account",
    },
  ];


  useEffect(() => {
    if (pathname === "/users/account") setKey("account");
    else if (pathname.includes("fundraisers")) setKey("fundraisers");
    else if (pathname === `/users/profile/${user_id}`) setKey("reviews");
    else if (pathname.includes("favorites")) setKey("favorites");
    else if (pathname.includes("preferences")) setKey("preferences");
    else if (pathname.includes("donations")) setKey("donations");
  }, [pathname, user_id]);


  return (
    <>
      <MetaComponent
        keywords=""
        description=""
        ogTitle=""
        ogDescription=""
        ogUrl=""
        ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
      />
      <MainTabSection>
        <Container className="cont-w">
          <Tab.Container activeKey={key}>
            <Nav
              className="responsive-tabs nav nav-tabs nav-fill"
            >
              {tabsList?.map((item, index: number) => (
                <Nav.Item key={index + 1}>
                  <Nav.Link
                    className={
                      item.key === key ? "active" : ""
                    }
                    eventKey={item.key}
                    as={Button}
                    onClick={() => {
                      setKey(item.key);
                      navigate(item.path);
                    }}
                  >
                    {item.title}
                  </Nav.Link>
                </Nav.Item>

              ))}
            </Nav>

            <Tab.Content>
              <Routes>
                <Route
                  index
                  path="/account"
                  element={<ManageAccountTab setKey={setKey} />}
                />
                <Route path="/profile/:user_id/*">
                  <Route path="" Component={MyReviewsTab} />
                  <Route path="fundraisers/*" Component={PersonalFundraisers} />
                  <Route path="favorites" Component={FavoriteNonprofits} />
                </Route>
                <Route
                  path="/preferences/:user_id"
                  Component={CausePreferences}
                />
                <Route path="/donations/:user_id" Component={MyDonationsTab} />
              </Routes>
            </Tab.Content>
          </Tab.Container>
        </Container>
      </MainTabSection>
    </>

  );
};
export default MyAccountTab;
